import { render, staticRenderFns } from "./AddGift.vue?vue&type=template&id=16ab2033&scoped=true&"
import script from "./AddGift.vue?vue&type=script&lang=js&"
export * from "./AddGift.vue?vue&type=script&lang=js&"
import style0 from "./AddGift.vue?vue&type=style&index=0&id=16ab2033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab2033",
  null
  
)

export default component.exports